module.exports = __webpack_public_path__ + "static/media/7.89d9a04d.jpg";